module.exports = __webpack_public_path__ + "img/about-values-hero.jpg?da94b56ec106b869a504b5b2411a281e";